// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assignment-result-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem;
}

.loading-section {
  text-align: center;
  padding: 4rem 2rem;
}

.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin: 0 auto 1.5rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-section h2 {
  font-size: 1.5rem;
  color: #212529;
  margin-bottom: 1rem;
}

.loading-section p {
  color: #6c757d;
  font-size: 1rem;
}

.error-section {
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
}

.error-section h2 {
  color: #721c24;
  margin-bottom: 1rem;
}

.error-section p {
  color: #721c24;
}

.result-header {
  text-align: center;
  margin-bottom: 2rem;
}

.result-header h2 {
  font-size: 2rem;
  font-weight: 600;
  color: #212529;
  margin-bottom: 1rem;
}

.result-subtitle {
  font-size: 1rem;
  color: #6c757d;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
}

.save-status {
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
}

.save-status.success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.save-status.saving {
  background: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

.save-status.error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.save-status.info {
  background: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

.save-status.info a {
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
}

.save-status.info a:hover {
  color: #0056b3;
}

.result-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.action-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.copy-btn {
  background: #007bff;
  color: white;
}

.copy-btn:hover {
  background: #0056b3;
}

.download-btn {
  background: #28a745;
  color: white;
}

.download-btn:hover {
  background: #218838;
}

.assignment-content {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.assignment-text {
  font-size: 1rem;
  line-height: 1.8;
  color: #212529;
}

.assignment-text p {
  margin-bottom: 1.5rem;
}

.assignment-text p:last-child {
  margin-bottom: 0;
}

/* Style for green visual requirements */
.assignment-text span[style*="color: #28a745"] {
  display: inline-block;
  margin: 0.25rem 0;
  padding: 0.25rem 0.5rem;
  border-left: 3px solid #28a745;
}

.result-footer {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 8px;
}

.info-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #28a745;
  font-size: 0.9rem;
  font-weight: 500;
}

.badge-icon {
  font-size: 1.2rem;
}

@media (max-width: 768px) {
  .assignment-result-container {
    padding: 1rem;
  }

  .result-header h2 {
    font-size: 1.5rem;
  }

  .result-actions {
    flex-direction: column;
  }

  .action-btn {
    width: 100%;
  }

  .result-footer {
    flex-direction: column;
    gap: 1rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/unAuth/components/AssignmentResult.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF","sourcesContent":[".assignment-result-container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.loading-section {\n  text-align: center;\n  padding: 4rem 2rem;\n}\n\n.loading-spinner {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 1.5rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-section h2 {\n  font-size: 1.5rem;\n  color: #212529;\n  margin-bottom: 1rem;\n}\n\n.loading-section p {\n  color: #6c757d;\n  font-size: 1rem;\n}\n\n.error-section {\n  background: #f8d7da;\n  border: 1px solid #f5c6cb;\n  border-radius: 8px;\n  padding: 2rem;\n  text-align: center;\n}\n\n.error-section h2 {\n  color: #721c24;\n  margin-bottom: 1rem;\n}\n\n.error-section p {\n  color: #721c24;\n}\n\n.result-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.result-header h2 {\n  font-size: 2rem;\n  font-weight: 600;\n  color: #212529;\n  margin-bottom: 1rem;\n}\n\n.result-subtitle {\n  font-size: 1rem;\n  color: #6c757d;\n  line-height: 1.6;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.save-status {\n  margin-top: 1rem;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.save-status.success {\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.save-status.saving {\n  background: #d1ecf1;\n  color: #0c5460;\n  border: 1px solid #bee5eb;\n}\n\n.save-status.error {\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.save-status.info {\n  background: #d1ecf1;\n  color: #0c5460;\n  border: 1px solid #bee5eb;\n}\n\n.save-status.info a {\n  color: #007bff;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.save-status.info a:hover {\n  color: #0056b3;\n}\n\n.result-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n}\n\n.action-btn {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.copy-btn {\n  background: #007bff;\n  color: white;\n}\n\n.copy-btn:hover {\n  background: #0056b3;\n}\n\n.download-btn {\n  background: #28a745;\n  color: white;\n}\n\n.download-btn:hover {\n  background: #218838;\n}\n\n.assignment-content {\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 12px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.assignment-text {\n  font-size: 1rem;\n  line-height: 1.8;\n  color: #212529;\n}\n\n.assignment-text p {\n  margin-bottom: 1.5rem;\n}\n\n.assignment-text p:last-child {\n  margin-bottom: 0;\n}\n\n/* Style for green visual requirements */\n.assignment-text span[style*=\"color: #28a745\"] {\n  display: inline-block;\n  margin: 0.25rem 0;\n  padding: 0.25rem 0.5rem;\n  border-left: 3px solid #28a745;\n}\n\n.result-footer {\n  display: flex;\n  gap: 1.5rem;\n  justify-content: center;\n  flex-wrap: wrap;\n  padding: 1.5rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.info-badge {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #28a745;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.badge-icon {\n  font-size: 1.2rem;\n}\n\n@media (max-width: 768px) {\n  .assignment-result-container {\n    padding: 1rem;\n  }\n\n  .result-header h2 {\n    font-size: 1.5rem;\n  }\n\n  .result-actions {\n    flex-direction: column;\n  }\n\n  .action-btn {\n    width: 100%;\n  }\n\n  .result-footer {\n    flex-direction: column;\n    gap: 1rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
